var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { redirectToPage } from "../helpers";
// import { submitEventFormAPI, makeAPaymentAPI, getPaymentApproved, getPaymentCancelled, getBankTransfer, getInitialData, getUserConsents, postUserConsents, getSepaDirectDebit, postSepaDirectDebitForm } from "../httpService";
import { getResponseManager } from "../responseManager/BeeResponseManager";
import { postBookingForm } from "./actions/response.actions";
import { APP_STATE } from "./store";
import get from "lodash/get";
import { isAdminIntegration } from "./statePresenter";
export * from "./actions/cart.actions";
export * from "./actions/global.actions";
export var RESET_STATE = Symbol("RESET_STATE");
var resetState = function (props) {
    if (props === void 0) { props = {}; }
    return ({
        type: RESET_STATE,
        payload: props
    });
};
export var SET_PAYMENT_SESSION_ID = Symbol("SET_PAYMENT_SESSION_ID");
export var setPaymentSessionId = function (payment_session_id) { return ({
    type: SET_PAYMENT_SESSION_ID,
    payment_session_id: payment_session_id
}); };
export var SET_CERTIFICATE_SESSION_ID = Symbol("SET_CERTIFICATE_SESSION_ID");
export var setCertificateSessionId = function (certificate_session_id) { return ({
    type: SET_CERTIFICATE_SESSION_ID,
    certificate_session_id: certificate_session_id
}); };
export var SET_PAYBOOK_REFERENCE_PAGE = Symbol("SET_PAYBOOK_REFERENCE_PAGE");
export var setPaybookReferencePage = function (paybookReferencePage) { return ({
    type: SET_PAYBOOK_REFERENCE_PAGE,
    paybookReferencePage: paybookReferencePage
}); };
export var SET_END_USER_ERROR = Symbol("SET_END_USER_ERROR");
export var setHasEndUserError = function (hasEndUserError) { return ({
    type: SET_END_USER_ERROR,
    hasEndUserError: hasEndUserError
}); };
export var SET_APP_STATE = Symbol("SET_APP_STATE");
var sendAppState = function (state) { return ({
    type: SET_APP_STATE,
    state: state
}); };
export var setAppState = function (state) {
    return function (dispatch, getState) {
        var resetNotifications = ![APP_STATE.CANCEL_BOOKING].includes(get(getState(), "appReducer.currentState"));
        if (state === APP_STATE.FORM || state === APP_STATE.TABLE) {
            dispatch(resetState({ resetNotifications: resetNotifications }));
        }
        ;
        dispatch(sendAppState(state));
    };
};
export var GET_INITIAL_OPTIONS = Symbol('GET_INITIAL_OPTIONS');
var getInitialOptions = function () { return ({
    type: GET_INITIAL_OPTIONS,
}); };
export var INITIAL_OPTIONS_SUCCESS = Symbol('INITIAL_OPTIONS_SUCCESS');
var initialOptionsSuccess = function (initialData) { return ({
    type: INITIAL_OPTIONS_SUCCESS,
    initialData: initialData
}); };
export var INITIAL_OPTIONS_FAIL = Symbol('INITIAL_OPTIONS_FAIL');
var initialOptionsFail = function (error) { return ({
    type: INITIAL_OPTIONS_FAIL,
    error: error
}); };
export var UPDATE_FILTERS = Symbol("UPDATE_FILTERS");
export var updateFilters = function (queryString) { return ({
    type: UPDATE_FILTERS,
    queryString: queryString
}); };
export var GET_EVENTS = Symbol('GET_EVENTS');
var getEvents = function () { return ({
    type: GET_EVENTS,
}); };
export var RECEIVE_EVENTS_SUCCESS = Symbol('RECEIVE_EVENTS_SUCCESS');
var receiveEventsSuccess = function (data) {
    return __assign({ type: RECEIVE_EVENTS_SUCCESS }, data);
};
export var RECEIVE_EVENTS_FAIL = Symbol('RECEIVE_EVENTS_FAIL');
var receiveEventsFail = function (error) {
    return {
        type: RECEIVE_EVENTS_FAIL,
        error: error,
    };
};
export var UPDATE_FORM_META = Symbol('UPDATE_FORM_META');
var updateFormMeta = function (filters) {
    if (filters === void 0) { filters = {}; }
    return __assign({ type: UPDATE_FORM_META }, filters);
};
export var UPDATE_FORM_VALUES = Symbol('UPDATE_FORM_VALUES');
var updateFormValues = function (form, source) {
    if (form === void 0) { form = {}; }
    return __assign(__assign({ type: UPDATE_FORM_VALUES }, form), { source: source });
};
export var PREPARE_WIZARD = Symbol("PREPARE_WIZARD");
var prepareWizard = function () {
    return {
        type: PREPARE_WIZARD,
    };
};
export var UPDATE_TOTAL_RECORDS = Symbol("UPDATE_TOTAL_RECORDS");
export var updateTotalRecords = function (totalRecords) { return ({
    type: UPDATE_TOTAL_RECORDS,
    totalRecords: totalRecords
}); };
export var SET_RESOLVED_COLUMNS = Symbol("SET_RESOLVED_COLUMNS");
export var setResolvedColumns = function (resolvedColumns, reset) { return ({
    type: SET_RESOLVED_COLUMNS,
    resolvedColumns: resolvedColumns,
    reset: reset
}); };
export var UPDATE_PAGE_SIZE = Symbol("UPDATE_PAGE_SIZE");
export var updatePageSize = function (pageSize) {
    return {
        type: UPDATE_PAGE_SIZE,
        pageSize: pageSize
    };
};
export var UPDATE_PAGE_NUMBER = Symbol("UPDATE_PAGE_NUMBER");
export var updatePageNumber = function (pageNumber) {
    return {
        type: UPDATE_PAGE_NUMBER,
        pageNumber: pageNumber
    };
};
export var RESET_BOOK_DATA = Symbol("RESET_BOOK_DATA");
export var resetBookData = function (paginated) {
    return {
        type: RESET_BOOK_DATA,
        pageNumber: paginated ? 1 : undefined,
    };
};
export var GO_TO_NEXT_PAGE = Symbol("GO_TO_NEXT_PAGE");
export var goToNextPage = function (lastPage) {
    return {
        type: GO_TO_NEXT_PAGE,
        lastPage: lastPage
    };
};
export var SET_FORM_META = Symbol('SET_FORM_META');
var setFormMeta = function (form) {
    if (form === void 0) { form = {}; }
    return __assign({ type: SET_FORM_META }, form);
};
export var SET_OPTIONS = Symbol('SET_OPTIONS');
export var setOptions = function (options) { return ({
    type: SET_OPTIONS,
    options: options
}); };
export var MAKE_A_BOOKING = Symbol("MAKE_A_BOOKING");
export var makeABooking = function () { return ({
    type: MAKE_A_BOOKING,
}); };
export var MAKE_A_BOOKING_SUCCESS = Symbol("MAKE_A_BOOKING_SUCCESS");
export var makeABookingSuccess = function (response) { return ({
    type: MAKE_A_BOOKING_SUCCESS,
    response: response
}); };
export var MAKE_A_BOOKING_FAIL = Symbol("MAKE_A_BOOKING_FAIL");
export var makeABookingFail = function (error) { return ({
    type: MAKE_A_BOOKING_FAIL,
    error: error
}); };
export var SEND_FLASH_NOTIFICATION = Symbol("SEND_FLASH_NOTIFICATION");
export var sendFlashNotification = function (notification) { return ({
    type: SEND_FLASH_NOTIFICATION,
    notification: notification
}); };
export var REMOVE_NOTIFICATION = Symbol("REMOVE_NOTIFICATION");
export var removeNotification = function (index) { return ({
    type: REMOVE_NOTIFICATION,
    index: index
}); };
export var SEND_VALIDATION_ERRORS = Symbol("SEND_VALIDATION_ERRORS");
export var sendFieldValidationErrors = function (validationErrors) { return ({
    type: SEND_VALIDATION_ERRORS,
    validationErrors: validationErrors
}); };
var updateFlashAndRedirect = function (dispatch, response, fallbackRoute) {
    var rm = getResponseManager(response);
    var flashNotifications = rm.flashNotifications();
    var fieldValidationErrors = rm.fieldValidationErrors();
    dispatch(sendFlashNotification(flashNotifications));
    dispatch(sendFieldValidationErrors(fieldValidationErrors));
    var redirectUrl = rm.redirectUrl();
    redirectToPage(redirectUrl, { fallbackRoute: fallbackRoute });
};
export var GET_PAYBOOK = Symbol("GET_PAYBOOK");
var getPaybook = function () { return ({
    type: GET_PAYBOOK
}); };
export var PAYBOOK_SUCCESS = Symbol("PAYBOOK_SUCCESS");
var paybookSuccess = function (response) { return ({
    type: PAYBOOK_SUCCESS,
    response: response
}); };
export var PAYBOOK_FAIL = Symbol("PAYBOOK_FAIL");
var paybookFail = function (error) { return ({
    type: PAYBOOK_FAIL,
    error: error
}); };
export var RESET_PAYBOOK_STATE = Symbol("RESET_PAYBOOK_STATE");
export var resetPaybook = function () { return ({
    type: RESET_PAYBOOK_STATE,
}); };
var hasUnhandledException = function (dispatch, response) {
    if (response.name === "unhandled_exception") {
        updateFlashAndRedirect(dispatch, response);
        return true;
    }
    return false;
};
// export const initializeOptions = () => {
//   return (dispatch: any, getState: any) => {
//     dispatch(getInitialOptions());
//     getInitialData()
//       .then((response) => {
//         dispatch(initialOptionsSuccess(response))
//         if (hasUnhandledException(dispatch, response)) return;
//       })
//       .catch((error) => {
//         console.error(error);
//         dispatch(initialOptionsFail(error))
//       })
//   }
// }
// export const fetchEvents = (queryString?: string) => {
//   return (dispatch: any, getState: any) => {
//     updateFlashAndRedirect(dispatch, {});
//     dispatch(getEvents());
//     dispatch(sendFieldValidationErrors(null));
//     getEventsData(queryString)
//       .then((response) => {
//         dispatch(receiveEventsSuccess(response))
//         if (hasUnhandledException(dispatch, response)) return;
//         dispatch(setFormMeta(response))
//       })
//       .catch((error) => {
//         console.error(error);
//         dispatch(receiveEventsFail(error))
//       })
//   }
// }
// export const startPaymentProcess = (sessionId) => {
//   return (dispatch: any ) => {
//     dispatch(getPaybook());
//     getPaymentInformation(sessionId)
//       .then((response) => {
//         updateFlashAndRedirect(dispatch, response);
//         dispatch(paybookSuccess(response));
//         if (hasUnhandledException(dispatch, response)) return;
//       })
//       .catch((error) => {
//         dispatch(paybookFail(error));
//       })
//   }
// }
export var START_PAYMENT = Symbol("START_PAYMENT");
export var startPayment = function () { return ({
    type: START_PAYMENT
}); };
export var START_PAYMENT_SUCCESS = Symbol("START_PAYMENT_SUCCESS");
export var startPaymentSuccess = function (response, redirecting) { return ({
    type: START_PAYMENT_SUCCESS,
    response: response, redirecting: redirecting
}); };
export var START_PAYMENT_FAIL = Symbol("START_PAYMENT_FAIL");
export var startPaymentFail = function (error) { return ({
    type: START_PAYMENT_FAIL,
    error: error
}); };
// export const submitPaymentForm = (request) => {
//   return (dispatch) => {
//     dispatch(sendFlashNotification({}));
//     dispatch(startPayment());
//     makeAPaymentAPI(request)
//       .then((response) => {
//         dispatch(startPaymentSuccess(response, "pay_book_pay_redirect" === response.name))
//         if (hasUnhandledException(dispatch, response)) return;
//         updateFlashAndRedirect(dispatch, response, ERoute.SUCCESS)
//       })
//       .catch((error) => dispatch(startPaymentFail(error)))
//   }
// }
export var updateForm = function (formObject, source) {
    if (formObject === void 0) { formObject = {}; }
    return function (dispatch) {
        var _a;
        dispatch(updateFormValues((_a = {}, _a[formObject.name] = formObject.form, _a), source));
    };
};
export var updateAdminSettings = function (form) { return function (dispatch, getState) {
    dispatch(updateForm({ "name": "adminsettings", form: form }, "adminsettings"));
}; };
export var patchForm = function (_a, source) {
    if (_a === void 0) { _a = {}; }
    var name = _a.name, formObject = __rest(_a, ["name"]);
    return function (dispatch, getState) {
        var _a;
        dispatch(updateFormValues((_a = {},
            _a[name] = __assign(__assign({}, get(getState(), "formReducer.forms." + name, {})), formObject),
            _a), source));
    };
};
// export const submitBookingForm = (request) => {
//   return (dispatch: any ) => {
//     updateFlashAndRedirect(dispatch, {});
//     dispatch(updateForm({ name: "payment-form", form: {} }));
//     dispatch(resetPaybook());
//     dispatch(makeABooking());
//     submitEventFormAPI(request)
//       .then((response) => {
//         dispatch(makeABookingSuccess(response));
//         if (hasUnhandledException(dispatch, response)) return;
//         let fallbackRoute;
//         switch(response.name) {
//           case "boooking_requires_payment": 
//             redirectToPage(getHashOrPath(ERoute.PAYBOOK));
//             break;
//           case "boooking_success":
//             fallbackRoute = ERoute.SUCCESS;
//           default:
//             updateFlashAndRedirect(dispatch, response, fallbackRoute);
//         }
//       })
//       .catch((error) => {
//         dispatch(makeABookingFail(error));
//       })
//   }
// }
// export const getPaymentApprovedResponse = (queryObject) => {
//   return (dispatch) => {
//     setHasEndUserError(false);
//     getPaymentApproved(queryObject)
//       .then((response) => {
//         if (hasUnhandledException(dispatch, response)) return;
//         let fallbackRoute;
//         switch(response.name) {
//           case "end_user_error":
//             dispatch(setHasEndUserError(true))
//             break;
//           case "payment_approved":
//             fallbackRoute = ERoute.SUCCESS;
//         }
//         updateFlashAndRedirect(dispatch, response, fallbackRoute);
//       })
//       .catch(() => {
//         console.debug("TODO: handle unexpected errors");
//       })
//   }
// }
// export const getPaymentCancelledResponse = (queryObject) => {
//   return (dispatch) => {
//     getPaymentCancelled(queryObject)
//       .then((response) => {
//         if (hasUnhandledException(dispatch, response)) return;
//         updateFlashAndRedirect(dispatch, response, ERoute.PAYBOOK);
//       })
//       .catch(() => {
//         console.debug("TODO: handle unexpected errors");
//       })
//   }
// }
export var MAKE_BANK_TRANSFER = Symbol("MAKE_BANK_TRANSFER");
export var makeBankTransfer = function () { return ({
    type: MAKE_BANK_TRANSFER
}); };
export var MAKE_BANK_TRANSFER_SUCCESS = Symbol("MAKE_BANK_TRANSFER_SUCCESS");
export var makeBankTransferSuccess = function (response) { return ({
    type: MAKE_BANK_TRANSFER_SUCCESS,
    response: response
}); };
export var MAKE_BANK_TRANSFER_FAIL = Symbol("MAKE_BANK_TRANSFER_FAIL");
export var makeBankTransferFail = function (error) { return ({
    type: MAKE_BANK_TRANSFER_FAIL,
    error: error
}); };
// export const getBankTransferResponse = (queryObject) => {
//   return (dispatch) => {
//     dispatch(makeBankTransfer());
//     getBankTransfer(queryObject)
//       .then((response) => {
//         if (hasUnhandledException(dispatch, response)) return;
//         dispatch(makeBankTransferSuccess(response));
//       })
//       .catch((error) => {
//         dispatch(makeBankTransferFail(error));
//         console.debug("TODO: handle unexpected errors");
//       })
//   }
// }
export var GET_CONSENTS = Symbol("GET_CONSENTS");
export var sendGetConsents = function () { return ({
    type: GET_CONSENTS
}); };
export var GET_CONSENTS_SUCCESS = Symbol("GET_CONSENTS_SUCCESS");
export var sendGetConsentsSuccess = function (response) { return ({
    type: GET_CONSENTS_SUCCESS,
    response: response
}); };
export var GET_CONSENTS_FAIL = Symbol("GET_CONSENTS_FAIL");
export var sendGetConsentsFail = function (error) { return ({
    type: GET_CONSENTS_SUCCESS,
    error: error
}); };
// export const fetchConsents = (token: string) => {
//   return (dispatch) => {
//     dispatch(sendGetConsents());
//     dispatch(sendFlashNotification({}))
//     getUserConsents(token)
//       .then((response) => {
//         if (hasUnhandledException(dispatch, response)) return;
//         updateFlashAndRedirect(dispatch, response);
//         dispatch((sendGetConsentsSuccess(response)))
//       })
//       .catch((error) => dispatch((sendGetConsentsFail(error))));
//   }
// };
export var SET_CONSENTS = Symbol("SET_CONSENTS");
export var sendSetConsents = function () { return ({
    type: SET_CONSENTS
}); };
export var SET_CONSENTS_SUCCESS = Symbol("SET_CONSENTS_SUCCESS");
export var sendSetConsentsSuccess = function (submitResponse) { return ({
    type: SET_CONSENTS_SUCCESS,
    submitResponse: submitResponse
}); };
export var SET_CONSENTS_FAIL = Symbol("SET_CONSENTS_FAIL");
export var sendSetConsentsFail = function (submitError) { return ({
    type: SET_CONSENTS_SUCCESS,
    submitError: submitError
}); };
// export const submitConsent = (tokem, form) => {
//   return (dispatch) => {
//     dispatch(sendSetConsents());
//     dispatch(sendFlashNotification({}))
//     postUserConsents(tokem, form)
//       .then((response) => {
//         if (hasUnhandledException(dispatch, response)) return;
//         updateFlashAndRedirect(dispatch, response);
//         dispatch((sendSetConsentsSuccess(response)))
//       })
//       .catch((error) => dispatch((sendSetConsentsFail(error))));
//   }
// }
export var GET_SEPA_DIRECT_DEBIT_ENTITIES = Symbol("GET_SEPA_DIRECT_DEBIT_ENTITIES");
export var getSepaDirectDebitEntities = function () { return ({
    type: GET_SEPA_DIRECT_DEBIT_ENTITIES,
}); };
export var GET_SEPA_DIRECT_DEBIT_ENTITIES_SUCCESS = Symbol("GET_SEPA_DIRECT_DEBIT_ENTITIES_SUCCESS");
export var getSepaDirectDebitEntitiesSuccess = function (response) { return ({
    type: GET_SEPA_DIRECT_DEBIT_ENTITIES_SUCCESS,
    response: response
}); };
export var GET_SEPA_DIRECT_DEBIT_ENTITIES_FAIL = Symbol("GET_SEPA_DIRECT_DEBIT_ENTITIES_FAIL");
export var getSepaDirectDebitEntitiesFail = function (error) { return ({
    type: GET_SEPA_DIRECT_DEBIT_ENTITIES_FAIL,
    error: error
}); };
// export const fetchSepaDirectDebit = (paymentSessionId) => {
//   return (dispatch) => {
//     dispatch(getSepaDirectDebitEntities())
//     dispatch(sendFlashNotification({}))
//     getSepaDirectDebit(paymentSessionId)
//     .then((response) => {
//       dispatch(getSepaDirectDebitEntitiesSuccess(response))
//       if (hasUnhandledException(dispatch, response)) return;
//     })
//     .catch((error) => {
//       dispatch(getSepaDirectDebitEntitiesFail(error))
//     })
//   }
// }
export var SUBMIT_SEPA_DIRECT_DEBIT_FORM = Symbol("SUBMIT_SEPA_DIRECT_DEBIT_FORM");
export var submitSepaDirectDebitForm = function () { return ({
    type: SUBMIT_SEPA_DIRECT_DEBIT_FORM,
}); };
export var SUBMIT_SEPA_DIRECT_DEBIT_FORM_SUCCESS = Symbol("SUBMIT_SEPA_DIRECT_DEBIT_FORM_SUCCESS");
export var submitSepaDirectDebitFormSuccess = function (response) { return ({
    type: SUBMIT_SEPA_DIRECT_DEBIT_FORM_SUCCESS,
    response: response
}); };
export var SUBMIT_SEPA_DIRECT_DEBIT_FORM_FAIL = Symbol("SUBMIT_SEPA_DIRECT_DEBIT_FORM_FAIL");
export var submitSepaDirectDebitFormFail = function (error) { return ({
    type: SUBMIT_SEPA_DIRECT_DEBIT_FORM_FAIL,
    error: error
}); };
export var submitBookingForm = function (requestObject, referencePage) {
    return function (dispatch, getState) {
        var isAdmin = isAdminIntegration(getState());
        return dispatch(postBookingForm(requestObject))
            .then(function (res) {
            !isAdmin && dispatch(setPaybookReferencePage(referencePage));
            return res;
        });
    };
};
export var UPDATE_CUSTOMER_ID = Symbol("UPDATE_CUSTOMER_ID");
export var updateCustomerId = function (customerId) { return ({
    type: UPDATE_CUSTOMER_ID,
    customerId: customerId !== null && customerId !== void 0 ? customerId : ""
}); };
// export const submitSepaDirectDebit = (paymentSessionId, form) => {
//   return (dispatch) => {
//     dispatch(submitSepaDirectDebitForm())
//     dispatch(sendFlashNotification({}))
//     postSepaDirectDebitForm(paymentSessionId, form)
//       .then((response) => {
//         if (hasUnhandledException(dispatch, response)) return;
//         dispatch(submitSepaDirectDebitFormSuccess(response))
//         updateFlashAndRedirect(dispatch, response);
//       })
//       .catch((error) => {
//         dispatch(submitSepaDirectDebitFormFail(error))
//       })
//   }
// }
